"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const OutlineIcons = __importStar(require("@heroicons/react/outline"));
const SolidIcons = __importStar(require("@heroicons/react/solid"));
const icons_1 = require("./icons");
const constants_1 = require("../../constants");
const color_1 = require("../../constants/color");
const create_styles_1 = require("../../utils/create-styles");
const styled_system_1 = require("../../utils/styled-system");
const IconElement = styled_1.default.div((props) => {
    const width = typeof props.size === 'number'
        ? props.size
        : constants_1.theme.elements.icon.size[props.size ?? 'md'];
    return {
        backgroundColor: props.backgroundColor ?? (props.round ? color_1.Color.LIGHT_GREY : undefined),
        borderRadius: 999,
        boxSizing: 'border-box',
        color: props.color,
        cursor: props.onClick ? 'pointer' : undefined,
        display: 'flex',
        flexShrink: 0,
        opacity: props.opacity,
        padding: props.round ? width / 8 : undefined,
        width,
        ...(0, styled_system_1.space)(props),
        ...(0, create_styles_1.createStyles)(props.styles),
    };
});
const StyledSvg = styled_1.default.svg(({ flipped }) => ({
    width: '100%',
    transform: flipped ? 'scaleX(-1)' : undefined,
}));
const getIconComponent = (name, design) => {
    if (name in icons_1.BemloIcons) {
        return icons_1.BemloIcons[name];
    }
    if (name in icons_1.customSolidIcons) {
        return design === 'solid'
            ? // eslint-disable-next-line import/namespace
                icons_1.customSolidIcons[name]
            : // eslint-disable-next-line import/namespace
                icons_1.customOutlineIcons[name];
    }
    return design === 'solid'
        ? // eslint-disable-next-line import/namespace
            SolidIcons[name]
        : // eslint-disable-next-line import/namespace
            OutlineIcons[name];
};
const Icon = (props) => {
    const Component = getIconComponent(props.name, props.design ?? 'outline');
    return ((0, jsx_runtime_1.jsx)(IconElement, { ...props, children: (0, jsx_runtime_1.jsx)(StyledSvg, { as: Component, flipped: props.flippedHorizontal }) }));
};
exports.Icon = Icon;
